import * as React from 'react';
import { grantedEntitlements } from '@authe/fe-commons/plans';
import { resolveLoadProfile, budgetFor } from '@authe/fe-commons/budgets';
import { jsx } from 'react/jsx-runtime';

// src/quota/PlanProvider.tsx
var UNKNOWN = { plan: null, granted: null, profile: "standard" };
var PlanContext = React.createContext(UNKNOWN);
function PlanProvider({
  plan,
  overrides,
  subscriptionMetadata,
  children
}) {
  const value = React.useMemo(
    () => ({
      plan: plan ?? null,
      granted: plan ? grantedEntitlements(plan, overrides ?? {}) : null,
      profile: resolveLoadProfile(plan?.metadata ?? null, subscriptionMetadata ?? null)
    }),
    [plan, overrides, subscriptionMetadata]
  );
  return /* @__PURE__ */ jsx(PlanContext.Provider, { value, children });
}
function usePlan() {
  return React.useContext(PlanContext);
}
function useEntitlement(entitlement) {
  const { granted } = usePlan();
  return granted === null || granted.has(entitlement);
}
function useEntitled() {
  const { granted } = usePlan();
  return React.useCallback(
    (entitlement) => !entitlement || granted === null || granted.has(entitlement),
    [granted]
  );
}
function useLoadBudget(name) {
  const { profile } = usePlan();
  return React.useMemo(() => budgetFor(name, profile), [name, profile]);
}

export { PlanProvider, useEntitled, useEntitlement, useLoadBudget, usePlan };
//# sourceMappingURL=chunk-K5UJI6CW.js.map
//# sourceMappingURL=chunk-K5UJI6CW.js.map